import React, { useCallback, useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import { getFormattedMessage } from "../../../../components/shared_components_registration"
import { parseDate } from "../../../utils"
import ToggleActionLayers from "../../../graphing/plotting/GraphComponents/ToggleActionLayers"

export default function CommentSearch({
  fontPct = 100,
  filteredActions = [],
  actions = [],
  setFilteredRunActions,
  disabled = false,
  intl,
}) {
  const getTextStr = (id, msg) => getFormattedMessage(id, msg, true, intl)
  const [searchInput, setSearchInput] = useState("")
  const handleCommentSearch = useCallback((e) => {
    e.preventDefault()
    setSearchInput(e.target.value)
  }, [])

  const actionMatchesSearch = useCallback((action, searchString) => {
    const searchFields = ["comment", "action"]
    return searchFields.some(
      (field) => action[field] != null && action[field].toLowerCase().match(searchString.toLowerCase()),
    )
  }, [])

  useEffect(() => {
    const filteredActions =
      searchInput.length === 0
        ? actions
        : actions.filter((action) => actionMatchesSearch(action, searchInput))

    // Show the newest actions at the top
    setFilteredRunActions(
      filteredActions.sort((a, b) => parseDate(b.timestamp).valueOf() - parseDate(a.timestamp).valueOf()),
    )
  }, [searchInput, actions])

  const [formDisabled, setFormDisabled] = useState(false)
  useEffect(() => {
    setFormDisabled(disabled)
  }, [disabled])

  return (
    <div
      style={{
        backgroundColor: "var(--lanzalake-white)",
        color: "var(--lanzalake-blue-primary)",
      }}
    >
      <div style={{ marginBottom: "0" }}>
        <div className={"row child-width-auto"} style={{ marginBottom: "1px", alignItems: "center" }}>
          <label htmlFor="commentsSearchInput" style={{ fontSize: `${fontPct}%`, padding: "0" }}>
            <span>
              {getTextStr("general.search", "Search Comments")} &nbsp;(
              <em>
                {filteredActions.length} {getTextStr("general.results", "Results")}
              </em>
              )
            </span>
          </label>
          &nbsp;
          <Button
            variant={"outline-primary"}
            className={"btn-sm"}
            style={{ fontSize: `${fontPct}%`, border: "1px solid var(--lanzalake-grey)", padding: "1px 6px" }}
            onClick={() => setSearchInput("")}
            disabled={formDisabled}
          >
            {getTextStr("general.clearButton", "Clear")}
          </Button>
          &nbsp;
          <ToggleActionLayers download={false} height={0} extraStyle={{ padding: "0 6px" }} />
        </div>
        <div className={"row"}>
          <input
            id={"commentsSearchInput"}
            type={"text"}
            placeholder={getTextStr("general.search", "ex. switched to T2R2, bad sample, etc.")}
            className={"form-control form-control-sm solid-grey-border"}
            value={searchInput}
            onChange={handleCommentSearch}
            style={{ fontSize: `${fontPct}%` }}
            disabled={formDisabled}
          />
        </div>
      </div>
    </div>
  )
}
